module.exports = __webpack_public_path__ + "img/recent.84b15df7.png";